import { Routes } from '@angular/router';
import { CallbackComponent } from '@app/callback/callback.component';
import { ElementsInfo } from '@app/core/shared/models/element';
import { ApplicationGuard } from '@shared/guards/application.guard';
import { UserPermissionsGuard } from '@shared/guards/user-permissions.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'elements', pathMatch: 'full' },
  {
    path: 'elements',
    canActivate: [ApplicationGuard],
    loadComponent: () =>
      import('./core/landing-page/landing-page.component').then(c => c.LandingPageComponent)
  },
  {
    path: 'notifications',
    data: { breadcrumb: 'Notifications' },
    canActivate: [ApplicationGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@core/notifications/notifications-page/notifications-page.component').then(
            c => c.NotificationsPageComponent
          )
      },
      {
        path: 'summary',
        data: { breadcrumb: 'Notification Summary' },
        loadComponent: () =>
          import('@core/notifications/notification-summary/notification-summary.component').then(
            m => m.NotificationSummaryComponent
          )
      }
    ]
  },
  {
    path: ElementsInfo.SURF.url,
    data: { breadcrumb: ElementsInfo.SURF.name.toUpperCase() },
    canActivate: [ApplicationGuard],
    canActivateChild: [UserPermissionsGuard],
    loadChildren: () => import('./surf/surf.module').then(m => m.SurfModule)
  },
  {
    path: ElementsInfo.PIPELINES.url,
    data: { breadcrumb: ElementsInfo.PIPELINES.name.toUpperCase() },
    canActivate: [ApplicationGuard],
    canActivateChild: [UserPermissionsGuard],
    loadChildren: () => import('./pipelines/pipelines.module').then(m => m.PipelinesModule)
  },
  {
    path: 'componentTree',
    data: { breadcrumb: 'Hierarchy Tree' },
    canActivate: [ApplicationGuard],
    loadChildren: () =>
      import('./core/installation-content/installation-content.module').then(m => m.InstallationContentModule)
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'error',
    loadComponent: () =>
      import('./core/shared/errors/error-pages/error-page.component').then(m => m.ErrorPageComponent)
  },
  {
    path: '404',
    canActivate: [ApplicationGuard],
    loadComponent: () =>
      import('./core/shared/errors/not-found/not-found.component').then(c => c.NotFoundComponent)
  },
  { path: '**', redirectTo: 'callback' }
];
